import { useActionHandle } from "../useActionHandle";
import type { IColumnInfo } from '@dbl/core/dataSource';

export function useFilterHandle(list: IColumnInfo[], notifyFun: Function) {
  const actionHandle = useActionHandle(list, notifyFun);
  return { ...actionHandle };
}
